<div class="jumbotron container-fluid">
    <div class="row">
        <div class="col-lg-5 col-md-7">
            <div class=" etiquetaFACeB2B display-4" [innerHTML]="'pub.listComponent.welcome' | translate"></div>
            <h1 translate>pub.listComponent.title</h1>
            <p class="d-none d-md-block" translate>pub.listComponent.introduction</p>
        </div>
        <div class="col-lg-7 col-md-5 portada d-none d-md-block"><img src="assets/images/imagenJumbotron2.png"></div>
        <div class="auxiliar col-12 ">
            <div class="col"></div>
            <div class="flecha"></div>
            <div class="col"></div>
        </div>
    </div>
</div>

<app-pub-menu></app-pub-menu>

<div class="container-fluid empresasdeFacturacion">
	<h5 class="text-center"><p [innerHTML]="'pub.listComponent.introduction2' | translate"></p>
	<span class="separador"></span></h5>

	<!--leyenda-->
	<div _ngcontent-c5="" class="card infoEmpresa">
		<div _ngcontent-c5="" class="card-body">
			<div class="icons_leyenda justify-content-center row">
		        <div class="col-3 col-sm" *ngFor="let application of applicationList">
		        	<i title="{{getApplicationTitle(application.name) | translate}}" class="icono fa {{getApplicationClass(application.name)}} fa-2x"></i> <span class="leyenda ng-binding" translate>{{getApplicationlabel(application.name)}}</span></div>
			</div>
		</div>
	</div>
	<!--Fin leyenda-->

	<!--Empresas-->
	<section>
		<div class="row tarjetasEmpresas">
			<!-- Empresa -->
			<article *ngFor="let empresa of invoicingServiceDataList" class="col-sm-6 col-lg-4 col-xs-12 empresaFacturacion">
				<div class="card-flip" *ngIf="empresa.invoicingService.servicesToOthers" [ngClass]="getCardClass(empresa.invoicingService.identifier)" >
					<div class="flip">
						<div class="front" (click)="onInvoicingServiceDataClicked(empresa.invoicingService.identifier)">
							<!-- front content -->
							<div class="card">
                                <img src="{{ empresa.logo }}" />
								<div class="card-block serviciosPrestados">
								    <div class="row justify-content-center row">
								        <div class="col" *ngFor="let application of empresa.applications"><i *ngIf="application.visible && application.active" title="{{application.description}}" class="icono col-12 fa {{getApplicationClass(application.name)}} fa-2x"></i></div>
		    						</div>
								</div>
							</div>
						</div>
						<div class="back">
							<!-- back content -->
							<div class="card">
								<div class="card-header">
									<div class="logoEmpresa col">
										<a href="{{empresa.url}}" target="_blank"><img src="{{ empresa.logo }}"></a>
									</div>
									<div class="card-link col">
										<div class="" *ngFor="let application of empresa.applications"><i *ngIf="application.visible && application.active" title="{{application.description}}" class="icono col-12 fa {{getApplicationClass(application.name)}} fa-1x"></i></div>
									</div>
								</div>
								<div class="card-body" (click)="onInvoicingServiceDataClicked(empresa.invoicingService.identifier)">
									<div class="textoInfo" innerHTML="{{empresa.description}}">
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</article>
			<!-- Empresa end -->
		</div>
	</section>
	<!--Empresas-->
</div>




// WEBPACK FOOTER //
// ./src/app/app-public/pub-invoicing-services-list/pub-invoicing-services-list.component.html